module.exports = __webpack_public_path__ + "static/media/beta-1.51bafe41.svg";